import { Link } from 'react-router-dom';
import { SURVEY_PATH } from '../survey/surveyData';
import Tile from './Tile';
import BuffySprite from './BuffySprite';
import { useMedia, useReveal } from './useReveal';

/* S6 closing CTA (page spec S6): a wide tile on the soft sky wallpaper,
   cropped to its light upper band (final design review: the pastel read
   lime / butter yellow, outside the owner's blue-green-purple family; the
   peach before it was the loudest block on the page).
   1000px+ it is a 240px banner (lead review 2026-09-29): the heading and the
   pill centered on the left; Buffy on the right, feet ON the bottom edge,
   saying the spec's second line, "Free for teachers.", in a small bubble
   beside his head whose center sits on the tile's vertical center, the same
   line as the left group's center. Narrower, the copy stacks on top and
   Buffy (128px) stands at the bottom right. The heading carries the bubble's
   words for screen readers. */
export default function ClosingCta() {
  const { ref, reveal, live, near } = useReveal({ amount: 0.45 });
  const big = useMedia('(min-width: 1000px)');
  return (
    <section className="cx-root cxs-section cxs-cta-sec" aria-labelledby="cxs-cta-h">
      <div className="cxs-wrap">
        <div ref={ref} className="cxs-cta-stage" data-reveal={reveal} data-live={live ? 'true' : 'false'}>
          <Tile wall="sky" pos="50% 28%" near={near} className={`cxs-cta-tile ${big ? 'is-banner' : 'is-stack'}`}>
            <div className="cxs-cta-copy">
              <h2 id="cxs-cta-h" className="cxs-cta-h cxs-in-rise">
                Connect the SAT to your classroom.
                <span className="cxs-sr"> Free for teachers.</span>
              </h2>
              <Link to={SURVEY_PATH} className="cxs-pill cxs-cta-pill cxs-in-rise" style={{ '--d': '140ms' }}>
                Set up my class
              </Link>
            </div>
          </Tile>
          <div className={`cxs-cta-say is-${big ? 192 : 128} cxs-in-pop`} style={{ '--d': '600ms' }} aria-hidden="true">
            Free for teachers.
          </div>
          <BuffySprite className={`cxs-cta-buffy is-${big ? 192 : 128}`} size={big ? 192 : 128} sequence={['wave', 'celebrate']} />
        </div>
      </div>
    </section>
  );
}
